import { combineReducers } from "@reduxjs/toolkit";
import user from "App/store/slices/user.slice";
import auth from "App/store/slices/auth.slice";
import toast from "App/store/slices/toast.slice";
import masters from "App/store/slices/masters.slice";
import dashboard from "App/store/slices/dashboard.slice";
import drivers from "App/store/slices/drivers.slice";
import fleet from "App/store/slices/fleet.slice";
import bookings from "App/store/slices/bookings.slice";
import payments from "App/store/slices/payments.slice";
import pageinfo from "App/store/slices/pageInfo.slice";
import supplier from "App/store/slices/supplier.slice";
import plan from "App/store/slices/plan.slice";

const rootReducer = combineReducers({
  user,
  auth,
  toast,
  masters,
  dashboard,
  drivers,
  fleet,
  bookings,
  payments,
  pageinfo,
  supplier,
  plan,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
